export default __webpack_public_path__ + "static/media/PSG-BNB.3debf59a.svg";